import { Injectable, inject } from '@angular/core';
import { SupabaseService } from '../../../shared/services/supabase.service';
import {
  ChannelDataStartRepository,
  type ChannelDataStarts,
  parseChannelDataStarts,
} from './channel-data-start-repository';

const REFERENCE_KEY = 'channel_data_start';

@Injectable()
export class SupabaseChannelDataStartRepository extends ChannelDataStartRepository {
  // Not AuthStore: that import is portal-domain-no-portal-outside-domain.
  private readonly supabase = inject(SupabaseService);

  async load(): Promise<ChannelDataStarts> {
    const { data, error } = await this.supabase.client
      .from('portal_references')
      .select('reference_data')
      .eq('reference_key', REFERENCE_KEY)
      .maybeSingle();
    if (error) throw error;
    return parseChannelDataStarts(data?.reference_data ?? null);
  }
}
